import { useNextEnvVars } from "@/components/context-providers/NextEnvVarsWrapper";
import { useRouter } from "next/router";

export function useCurrentCanonicalUrl() {
  const router = useRouter();
  const { CHALK_FRONTEND_HOST } = useNextEnvVars();
  const host = CHALK_FRONTEND_HOST || "https://chalk.ai";
  const url = new URL(router.asPath, host);
  return url.toString().replace("www.", "");
}

export function canonicalUrlIsChalkDev(url: string) {
  return url.includes("chalk.dev");
}
export function canonicalUrlIsChalkPreprod(url: string) {
  return url.includes("staging.chalk.ai");
}
export function canonicalUrlIsLocal(url: string) {
  return url.includes("localhost");
}
export function canonicalUrlIsProduction(url: string) {
  return (
    !canonicalUrlIsChalkDev(url) && !canonicalUrlIsChalkPreprod(url) && !canonicalUrlIsLocal(url)
  );
}

export function urlIsRelative(url: string) {
  return !url.startsWith("http");
}
